import React from "react";
import { Globe } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

export default function LanguageToggle() {
  const { lang, setLang } = useLanguage();

  return (
    <div
      data-testid="language-toggle"
      className="inline-flex items-center gap-2 rounded-full border border-[rgba(212,175,55,0.6)] bg-black/40 backdrop-blur-md px-2 py-1 shadow-[0_0_18px_rgba(212,175,55,0.18)]"
    >
      <Globe className="w-3.5 h-3.5 text-[#d4af37] ml-1.5" strokeWidth={1.6} />
      <button
        data-testid="lang-btn-en"
        onClick={() => setLang("en")}
        aria-pressed={lang === "en"}
        className={`relative px-3 py-1 text-xs font-semibold tracking-[0.18em] rounded-full transition-all duration-300 ${
          lang === "en"
            ? "bg-gradient-to-br from-[#f6e27a] to-[#b8860b] text-[#0a0a0a] shadow-[0_0_14px_rgba(255,215,0,0.45)]"
            : "text-[#d4af37] hover:text-white"
        }`}
      >
        EN
      </button>
      <button
        data-testid="lang-btn-es"
        onClick={() => setLang("es")}
        aria-pressed={lang === "es"}
        className={`relative px-3 py-1 text-xs font-semibold tracking-[0.18em] rounded-full transition-all duration-300 ${
          lang === "es"
            ? "bg-gradient-to-br from-[#f6e27a] to-[#b8860b] text-[#0a0a0a] shadow-[0_0_14px_rgba(255,215,0,0.45)]"
            : "text-[#d4af37] hover:text-white"
        }`}
      >
        ES
      </button>
    </div>
  );
}
